<template>
  <el-row>
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>疾病</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_13.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #FDEB3A;">疾病</el-row>
                <el-row :span="24" class="hintClass">近期最常爆发</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_dis_1">
                  {{ disease.disease_dis_1.dis }}：{{ disease.disease_dis_1.cnt.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_dis_2">
                  {{ disease.disease_dis_2.dis }}：{{ disease.disease_dis_2.cnt.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_dis_3">
                  {{ disease.disease_dis_3.dis }}：{{ disease.disease_dis_3.cnt.toLocaleString() }}
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_14.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #FDEB3A;">机构</el-row>
                <el-row :span="24" class="hintClass">近期最常爆发</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_shengqu_1">
                  {{ disease.disease_shengqu_1.name }}：{{ disease.disease_shengqu_1.cnt.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_shengqu_2">
                  {{ disease.disease_shengqu_2.name }}：{{ disease.disease_shengqu_2.cnt.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.disease_shengqu_3">
                  {{ disease.disease_shengqu_3.name }}：{{ disease.disease_shengqu_3.cnt.toLocaleString() }}
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_14.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #FDEB3A;">疾病</el-row>
                <el-row :span="24" class="hintClass">近期收入最多</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;white-space: nowrap;" v-if="disease.disease_totalprice_1 && disease.disease_totalprice_1.name">
                  {{ disease.disease_totalprice_1.name }}：{{ disease.disease_totalprice_1.val.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;white-space: nowrap;" v-if="disease.disease_totalprice_2 && disease.disease_totalprice_2.name">
                  {{ disease.disease_totalprice_2.name }}：{{ disease.disease_totalprice_2.val.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;white-space: nowrap;" v-if="disease.disease_totalprice_3 && disease.disease_totalprice_3.name">
                  {{ disease.disease_totalprice_3.name }}：{{ disease.disease_totalprice_3.val.toLocaleString() }}
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_14.png"/>
              </el-col>
              <el-col :span="8">
                <el-row class="numClass" style=" color: #FDEB3A;">慢性病</el-row>
                <el-row :span="24" class="hintClass">近期最常见</el-row>
              </el-col>
              <el-col :span="11" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.freq_manxing_1">
                  {{ disease.freq_manxing_1.name }}：{{ disease.freq_manxing_1.val.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.freq_manxing_2">
                  {{ disease.freq_manxing_2.name }}：{{ disease.freq_manxing_2.val.toLocaleString() }}
                </el-row>
                <el-row class="numClass-small" style="color: #FDEB3A;font-size: 15px;line-height: 18px;" v-if="disease.freq_manxing_3">
                  {{ disease.freq_manxing_3.name }}：{{ disease.freq_manxing_3.val.toLocaleString() }}
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
export default {
  name: "DiseaseReportSection",
  props: {
    // 疾病统计数据，保持与旧页面一致
    disease: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped src="./list.css"></style>
